const key = 'documentShare.pendingInvitation';
const tokenPattern = /^[a-f0-9]{64}$/;
const lifetime = 7 * 24 * 60 * 60 * 1000;
export const invitationTokenFromHash = (hash: string): string | null => {
  const token = hash.startsWith('#') ? hash.slice(1) : '';
  return tokenPattern.test(token) ? token : null;
};
// Fragment 不傳給伺服器；只在同一分頁保存邀請，不放入登入 query 或 localStorage。
export function rememberDocumentInvitation(token: string): boolean {
  if (!tokenPattern.test(token)) return false;
  try {
    sessionStorage.setItem(key, JSON.stringify({ token, until: Date.now() + lifetime }));
    return true;
  } catch { return false; }
}
export function pendingDocumentInvitation(): string | null {
  try {
    const value = JSON.parse(sessionStorage.getItem(key) || 'null');
    if (value && tokenPattern.test(value.token) && typeof value.until === 'number' && value.until > Date.now() && value.until <= Date.now() + lifetime) return value.token;
    sessionStorage.removeItem(key);
  } catch { /* 儲存被停用時可重新開啟邀請信。 */ }
  return null;
}
export function clearDocumentInvitation(): void {
  try { sessionStorage.removeItem(key); } catch { /* 不影響伺服器端結果。 */ }
}
